<app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
  @if ({
    jobseekerLanguage: jobseekerLanguage$ | async,
    languageList: languageList$ | async,
    languageProficiencyLevelList: languageProficiencyLevelList$ | async,
    languageHasAttachment: languageHasAttachment$ | async,
    selectedFile: selectedFile$ | async,
    isFileUploading: isFileUploading$ | async,
    selectedFileText: selectedFileText$ | async,
    systemConfigs: systemConfigs$ | async,
    isFileSizeValid: isFileSizeValid$ | async
  }; as data) {
    <form [formGroup]="editForm" #ngForm="ngForm" [appConnectForm]="data.jobseekerLanguage" class="language-edit">
      <div class="language-edit__header">
        <h2 class="language-edit__title">{{ title | translate }}</h2>
        <button type="button" class="language-edit__close" [mat-dialog-close]="true" [attr.aria-label]="'label.Close' | translate">
          <svg-icon src="/assets/icons/dialog-close.svg"></svg-icon>
        </button>
      </div>

      <div class="language-edit__body">
        <div class="fields">
          <div>
            @if (isCreateForm) {
              <hrra-floating-field>
                <p-select
                  inputId="language-edit-language"
                  formControlName="worldLanguageId"
                  [options]="data.languageList"
                  optionLabel="name"
                  optionValue="value"
                  [filter]="true"
                  filterBy="name"
                  [class.has-error]="editForm.controls['worldLanguageId'].hasError('required') && (editForm.controls['worldLanguageId'].touched || ngForm.submitted)"
                  appDialogPanel>
                </p-select>
                <label for="language-edit-language">{{ 'label.ChooseLanguage' | translate }} *</label>
              </hrra-floating-field>
              @if (editForm.controls['worldLanguageId'].hasError('required') && (editForm.controls['worldLanguageId'].touched || ngForm.submitted)) {
                <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
              }
            } @else {
              <!-- the language of a saved entry can't be changed, only its level -->
              <hrra-floating-field>
                <input pInputText id="language-edit-language" type="text" [value]="data.jobseekerLanguage?.name" disabled>
                <label for="language-edit-language">{{ 'label.Language' | translate }}</label>
              </hrra-floating-field>
            }
          </div>

          <div>
            <hrra-floating-field>
              <p-select
                inputId="language-edit-level"
                formControlName="languageProficiencyLevelId"
                [options]="data.languageProficiencyLevelList"
                optionLabel="name"
                optionValue="value"
                [class.has-error]="editForm.controls['languageProficiencyLevelId'].hasError('required') && (editForm.controls['languageProficiencyLevelId'].touched || ngForm.submitted)"
                appDialogPanel>
              </p-select>
              <label for="language-edit-level">{{ 'label.LevelOfKnowledge' | translate }} *</label>
            </hrra-floating-field>
            @if (editForm.controls['languageProficiencyLevelId'].hasError('required') && (editForm.controls['languageProficiencyLevelId'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div class="attachment">
            @if (data.languageHasAttachment) {
              <button type="button" class="attachment-link" (click)="downloadAttachment(data.jobseekerLanguage?.objectId, jobseekerId)">
                <svg-icon src="/assets/icons/profile-attachment.svg" class="attachment-link__icon"></svg-icon>
                {{ 'label.Attachment' | translate }}
              </button>
            }

            <hrra-file-upload
              [label]="(data.languageHasAttachment ? 'label.Change' : 'label.AttachDocument') | translate"
              [hint]="'label.EgCertificate' | translate"
              [fileName]="data.selectedFile?.filename != null ? data.selectedFileText : null"
              [uploading]="data.isFileUploading"
              [invalid]="data.isFileSizeValid === false"
              (fileSelected)="onFileSelect($event, data.systemConfigs.jobseeker.jobseekerAttachmentMaxSize)">
            </hrra-file-upload>

            @if (data.isFileSizeValid === false) {
              <mat-error class="validation-message">{{ 'message.JobseekerFileSizeValidation' | translate }}</mat-error>
            }
          </div>
        </div>

        <div class="actions">
          <button
            type="submit"
            class="actions__button actions__button--save"
            (click)="onSave(data.selectedFile?.filename, data.isFileSizeValid)">
            {{ 'label.Save' | translate }}
          </button>
          <button type="button" class="actions__button actions__button--cancel" [mat-dialog-close]="true">{{ 'label.Cancel' | translate }}</button>
        </div>
      </div>
    </form>
  }
</app-spinner>
